import React, { useState, useEffect } from 'react';
import { Card, Button, Row, Col, Typography, Timeline, Drawer } from 'antd';
import { useHistory } from 'react-router-dom';
import { ArrowLeftOutlined, MenuOutlined } from '@ant-design/icons';
import '../../styles/mobile.css';
import { trackWellnessPageView } from '../../utils/analytics';
import calmiSafetyImage from '../../assets/images/calmi_safety_image.png';
import unicornImage from '../../assets/images/Classic Unicorn.png';
import squishyBearImage from '../../assets/images/Squish Bear.png';
import squishyLionImage from '../../assets/images/Squish Lion.png';

const { Title, Text, Paragraph } = Typography;

const CalmiPlatform = () => {
  const history = useHistory();
  const [mobileMenuVisible, setMobileMenuVisible] = useState(false);

  useEffect(() => {
    trackWellnessPageView('platform');
  }, []);

  return (
    <div style={{ minHeight: '100vh', background: '#fff', position: 'relative' }}>
      {/* Add CSS animation */}
      <style>
        {`
          @keyframes float {
            0%, 100% { transform: translateY(0px) rotate(var(--rotation)); }
            50% { transform: translateY(-8px) rotate(var(--rotation)); }
          }
          .floating-calmi {
            animation: float 3s ease-in-out infinite;
            cursor: pointer;
            transition: transform 0.3s ease;
          }
          .floating-calmi:hover {
            transform: scale(1.1) rotate(var(--rotation)) !important;
          }
        `}
      </style>

      {/* Header */}
      <div style={{ 
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        padding: '20px 0',
        marginBottom: '0',
        position: 'relative',
        zIndex: 1
      }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
          <Button 
            type="text" 
            icon={<ArrowLeftOutlined />} 
            onClick={() => history.push('/')}
            style={{ color: 'white', marginBottom: '10px' }}
          >
            Back to Lumi Bears
          </Button>
          {/* Mobile Layout */}
          <div style={{ display: 'block' }}>
            {/* Top row with logo and menu button */}
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '10px'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', flex: 1, minWidth: 0 }}>
                <span style={{ fontSize: '32px', marginRight: '15px', flexShrink: 0 }}>🛡️</span>
                <div>
                  <Title level={2} style={{ color: 'white', margin: 0, fontSize: '20px' }}>
                    Safety
                  </Title>
                  <Text style={{ color: 'rgba(255,255,255,0.8)', fontSize: '14px' }}>
                    Child safety and family privacy at the core
                  </Text>
                </div>
              </div>
              
              {/* Desktop navigation - hidden on mobile */}
              <div className="desktop-nav" style={{ 
                gap: '8px', 
                alignItems: 'center'
              }}>
                <Button
                  onClick={() => history.push('/')}
                  style={{
                    background: 'rgba(255, 255, 255, 0.1)',
                    color: 'white',
                    borderColor: 'rgba(255, 255, 255, 0.3)',
                    borderRadius: '20px',
                    height: '36px',
                    fontSize: '14px',
                    fontWeight: '500',
                    padding: '0 16px'
                  }}
                >
                  Find Your Companion
                </Button>
                <Button
                  onClick={() => history.push('/wellness')}
                  style={{
                    background: 'rgba(255, 255, 255, 0.1)',
                    color: 'white',
                    borderColor: 'rgba(255, 255, 255, 0.3)',
                    borderRadius: '20px',
                    height: '36px',
                    fontSize: '14px',
                    fontWeight: '500',
                    padding: '0 16px'
                  }}
                >
                  How We Help
                </Button>
                <Button
                  onClick={() => history.push('/blog')}
                  style={{
                    background: 'rgba(255, 255, 255, 0.1)',
                    color: 'white',
                    borderColor: 'rgba(255, 255, 255, 0.3)',
                    borderRadius: '20px',
                    height: '36px',
                    fontSize: '14px',
                    fontWeight: '500',
                    padding: '0 16px'
                  }}
                >
                  Blog
                </Button>
              </div>

              {/* Mobile menu button */}
              <div className="mobile-nav">
                <Button
                  type="text"
                  icon={<MenuOutlined />}
                  onClick={() => setMobileMenuVisible(true)}
                  style={{
                    color: 'white',
                    fontSize: '18px',
                    padding: '0',
                    height: '36px',
                    width: '36px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px', position: 'relative', zIndex: 1 }}>
        

        {/* Hero Section */}
        <div style={{ 
          marginBottom: '80px',
          background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
          borderRadius: '20px',
          padding: '60px 40px',
          position: 'relative',
          overflow: 'hidden'
        }}>
          <Row gutter={[48, 32]} align="middle" style={{ position: 'relative', zIndex: 2 }}>
            <Col xs={24} lg={12}>
              <Title level={1} style={{ 
                fontSize: '3.5rem', 
                marginBottom: '20px', 
                color: '#2c3e50',
                fontWeight: '700',
                textAlign: 'center'
              }}>
                A Safe Platform<br/>Parents Can Trust
              </Title>
              <Paragraph style={{ 
                fontSize: '22px', 
                color: '#7f8c8d', 
                marginBottom: '40px',
                textAlign: 'center'
              }}>
                Advanced technology designed with comprehensive safety measures, 
                complete transparency, and unwavering respect for your family's privacy.
              </Paragraph>
            </Col>
            <Col xs={24} lg={12} style={{ textAlign: 'center' }}>
              <div style={{
                background: 'rgba(255,255,255,0.9)',
                borderRadius: '20px',
                padding: '40px',
                display: 'inline-block',
                boxShadow: '0 10px 30px rgba(0,0,0,0.1)'
              }}>
                <img 
                  src={calmiSafetyImage} 
                  alt="Lumi safety and technology platform"
                  style={{ 
                    maxWidth: '300px',
                    width: '100%',
                    height: 'auto',
                    borderRadius: '15px'
                  }}
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.parentNode.innerHTML = '<div style="font-size: 120px; opacity: 0.8;">🛡️</div>';
                  }}
                />
              </div>
            </Col>
          </Row>
          <div style={{ textAlign: 'center', marginTop: '40px' }}>
            <Button 
              type="primary" 
              size="large"
              style={{
                background: '#e74c3c',
                borderColor: '#e74c3c',
                height: '50px',
                fontSize: '18px',
                fontWeight: 'bold',
                padding: '0 40px',
                marginRight: '16px'
              }}
              onClick={() => {
                document.getElementById('safety-features').scrollIntoView({ 
                  behavior: 'smooth' 
                });
              }}
            >
              Learn About Safety
            </Button>
            <Button 
              size="large"
              style={{
                height: '50px',
                fontSize: '18px',
                padding: '0 40px'
              }}
              onClick={() => history.push('/')}
            >
              Explore Companions
            </Button>
          </div>
        </div>

        {/* Safety First Framework */}
        <div id="safety-features" style={{ marginBottom: '120px' }}>
          <Title level={2} style={{ 
            textAlign: 'center', 
            marginBottom: '60px',
            fontSize: '2.5rem',
            fontWeight: '600',
            color: '#1a1a1a',
            letterSpacing: '-0.01em'
          }}>
            Safety-First Technology Framework
          </Title>
          <div style={{ position: 'relative', paddingRight: '200px' }}>
            {/* Floating Calmi - Right aligned */}
            <div style={{ position: 'absolute', right: '20px', top: '20px' }}>
              <img 
                src={unicornImage} 
                alt="Lumi Unicorn"
                className="floating-calmi"
                style={{ 
                  width: '160px', 
                  height: 'auto',
                  '--rotation': '-18deg'
                }}
                onClick={() => history.push('/products/calmi-unicorn')}
              />
            </div>
            
            <Row gutter={[32, 32]}>
                <Col xs={24} md={12}>
                  <div style={{ padding: '20px' }}>
                    <Title level={4}>🔒 Multi-Layer Protection</Title>
                <Paragraph style={{ fontSize: '16px' }}>
                  Every interaction is designed with child safety as the primary concern. We've built multiple 
                  layers of protection, parent oversight, and content filtering to ensure your child's 
                  digital companion remains a positive influence.
                </Paragraph>
              </div>
            </Col>
            <Col xs={24} md={12}>
              <div style={{ padding: '20px' }}>
                <Title level={4}>🎯 Age-Appropriate Filtering</Title>
                <Paragraph style={{ fontSize: '16px' }}>
                  Our advanced content filtering system ensures all conversations are developmentally appropriate, 
                  educational, and aligned with healthy child development principles. No inappropriate content can pass through.
                </Paragraph>
                  </div>
                </Col>
            </Row>
          </div>
        </div>

        {/* Complete Parent Oversight & Control */}
        <Card style={{ marginBottom: '60px', borderRadius: '15px' }}>
            <Title level={2} style={{ textAlign: 'center', marginBottom: '40px' }}>
              Complete Parent Oversight & Control
            </Title>
            <div style={{ position: 'relative', paddingRight: '200px' }}>
              {/* Floating Calmi - Right aligned */}
              <div style={{ position: 'absolute', right: '20px', top: '20px' }}>
                <img 
                  src={squishyBearImage} 
                  alt="Lumi Squishy Bear"
                  className="floating-calmi"
                  style={{ 
                    width: '150px', 
                    height: 'auto',
                    '--rotation': '22deg'
                  }}
                  onClick={() => history.push('/products/calmi-squishy-bear')}
                />
              </div>
              
              <Row gutter={[32, 32]}>
                  <Col xs={24} md={8}>
                <div style={{ textAlign: 'center', padding: '20px' }}>
                  <div style={{ fontSize: '48px', marginBottom: '20px' }}>📱</div>
                  <Title level={4}>Real-Time Dashboard</Title>
                  <Paragraph>
                    View live transcripts of every conversation, track emotional themes, 
                    and receive insights about your child's daily interactions.
                  </Paragraph>
                </div>
              </Col>
              <Col xs={24} md={8}>
                <div style={{ textAlign: 'center', padding: '20px' }}>
                  <div style={{ fontSize: '48px', marginBottom: '20px' }}>🎚️</div>
                  <Title level={4}>Conversation Controls</Title>
                  <Paragraph>
                    Set time limits, choose conversation topics, adjust personality settings, 
                    and create custom boundaries for your family's values.
                  </Paragraph>
                </div>
              </Col>
              <Col xs={24} md={8}>
                <div style={{ textAlign: 'center', padding: '20px' }}>
                  <div style={{ fontSize: '48px', marginBottom: '20px' }}>🔔</div>
                  <Title level={4}>Instant Alerts</Title>
                  <Paragraph>
                    Receive immediate notifications if concerning topics arise, 
                    plus daily summaries of your child's emotional check-ins.
                  </Paragraph>
                </div>
                  </Col>
              </Row>
            </div>
        </Card>

        {/* Privacy & Data Protection */}
        <Card style={{ marginBottom: '60px', borderRadius: '15px' }}>
          <Title level={2} style={{ textAlign: 'center', marginBottom: '40px' }}>
            Privacy & Data Protection
          </Title>
          <Row gutter={[32, 32]}>
            <Col xs={24} md={12}>
              <div>
                <Title level={4}>🔒 Local-First Processing</Title>
                <ul style={{ fontSize: '16px' }}>
                  <li style={{ marginBottom: '8px' }}>Wellness processing happens on your home network</li>
                  <li style={{ marginBottom: '8px' }}>Conversations stored locally on your devices</li>
                  <li style={{ marginBottom: '8px' }}>No audio recordings sent to external servers</li>
                  <li style={{ marginBottom: '8px' }}>Parent dashboard accessible only to your family</li>
                </ul>
              </div>
            </Col>
            <Col xs={24} md={12}>
              <div>
                <Title level={4}>🛡️ Security Measures</Title>
                <ul style={{ fontSize: '16px' }}>
                  <li style={{ marginBottom: '8px' }}>End-to-end encryption for all data</li>
                  <li style={{ marginBottom: '8px' }}>Regular security audits and updates</li>
                  <li style={{ marginBottom: '8px' }}>COPPA-compliant data practices</li>
                  <li style={{ marginBottom: '8px' }}>Option to delete all data anytime</li>
                </ul>
              </div>
            </Col>
          </Row>
          <div style={{ marginTop: '30px', padding: '20px', background: '#f0f8ff', borderRadius: '10px', textAlign: 'center' }}>
            <Text strong style={{ fontSize: '16px' }}>
              Internet connection required for initial setup and periodic updates only. 
              Daily conversations happen offline for maximum privacy.
            </Text>
          </div>
        </Card>

        {/* Technical Approach */}
        <Card style={{ marginBottom: '60px', borderRadius: '15px' }}>
          <Title level={2} style={{ textAlign: 'center', marginBottom: '40px' }}>
            Our Technical Approach
          </Title>
          <Timeline mode="alternate">
            <Timeline.Item dot={<div style={{ background: '#52c41a', width: '12px', height: '12px', borderRadius: '50%' }} />}>
              <Title level={4}>Child-Safe Technology Training</Title>
              <Paragraph>
                Our technology models are trained exclusively on child development research, therapeutic techniques, 
                and age-appropriate content. No social media data or unfiltered internet content.
              </Paragraph>
            </Timeline.Item>
            <Timeline.Item dot={<div style={{ background: '#1890ff', width: '12px', height: '12px', borderRadius: '50%' }} />}>
              <Title level={4}>Multi-Layer Content Filtering</Title>
              <Paragraph>
                Three independent systems check every response: content filters, safety validators, 
                and age-appropriateness reviewers before any words are spoken.
              </Paragraph>
            </Timeline.Item>
            <Timeline.Item dot={<div style={{ background: '#faad14', width: '12px', height: '12px', borderRadius: '50%' }} />}>
              <Title level={4}>Gentle Guidance</Title>
              <Paragraph>
                Our smart conversation system ensures all interactions remain positive, supportive, 
                and aligned with healthy child development and family values.
              </Paragraph>
            </Timeline.Item>
            <Timeline.Item dot={<div style={{ background: '#f5222d', width: '12px', height: '12px', borderRadius: '50%' }} />}>
              <Title level={4}>Parent Integration</Title>
              <Paragraph>
                Complete transparency with parents through detailed reporting, conversation logs, 
                and regular insights about your child's daily interactions and interests.
              </Paragraph>
            </Timeline.Item>
          </Timeline>
        </Card>

        {/* Floating Calmi - Between Privacy and COPPA */}
        <div style={{ display: 'flex', justifyContent: 'flex-start', marginBottom: '60px' }}>
          <img 
            src={squishyLionImage} 
            alt="Lumi Squishy Lion"
            className="floating-calmi"
            style={{ 
              width: '175px', 
              height: 'auto',
              '--rotation': '15deg'
            }}
            onClick={() => history.push('/products/calmi-squishy-lion')}
          />
        </div>

        {/* COPPA Leadership */}
        <Card style={{ marginBottom: '60px', borderRadius: '15px', background: '#f0f8ff' }}>
          <Title level={2} style={{ textAlign: 'center', marginBottom: '40px' }}>
            Leading the Industry in Child Privacy Protection
          </Title>
          
          {/* What is COPPA */}
          <div style={{ marginBottom: '40px', padding: '30px', background: '#fff', borderRadius: '15px' }}>
            <Title level={3} style={{ color: '#1890ff', marginBottom: '20px' }}>
              📋 What is COPPA?
            </Title>
            <Paragraph style={{ fontSize: '16px', marginBottom: '15px' }}>
              The <strong>Children's Online Privacy Protection Act (COPPA)</strong> is a federal law that protects 
              the privacy of children under 13 online. Enacted in 1998 and enforced by the FTC, COPPA requires 
              special safeguards for collecting, using, or disclosing personal information from children.
            </Paragraph>
            <Paragraph style={{ fontSize: '16px' }}>
              COPPA isn't just a legal requirement—it represents the gold standard for protecting children's 
              digital rights and ensuring parents maintain control over their child's online experiences.
            </Paragraph>
          </div>

          {/* Why COPPA Matters */}
          <div style={{ marginBottom: '40px', padding: '30px', background: '#fff3cd', borderRadius: '15px', border: '2px solid #ffc107' }}>
            <Title level={3} style={{ color: '#856404', marginBottom: '20px' }}>
              🛡️ Why COPPA Compliance Matters for Your Family
            </Title>
            <Row gutter={[24, 24]}>
              <Col xs={24} md={12}>
                <ul style={{ fontSize: '16px', marginLeft: '15px' }}>
                  <li style={{ marginBottom: '10px' }}>
                    <strong>Parent Control:</strong> You decide what information your child can share
                  </li>
                  <li style={{ marginBottom: '10px' }}>
                    <strong>Data Protection:</strong> Strict limits on collecting and storing child data
                  </li>
                  <li style={{ marginBottom: '10px' }}>
                    <strong>Transparency:</strong> Clear disclosure of all data practices
                  </li>
                </ul>
              </Col>
              <Col xs={24} md={12}>
                <ul style={{ fontSize: '16px', marginLeft: '15px' }}>
                  <li style={{ marginBottom: '10px' }}>
                    <strong>Safe Interactions:</strong> Age-appropriate content and communication
                  </li>
                  <li style={{ marginBottom: '10px' }}>
                    <strong>No Tracking:</strong> Prohibited from using child data for targeted advertising
                  </li>
                  <li style={{ marginBottom: '10px' }}>
                    <strong>Deletion Rights:</strong> Parents can request deletion of child's information
                  </li>
                </ul>
              </Col>
            </Row>
          </div>

          {/* How Calmi Ensures Compliance */}
          <div style={{ marginBottom: '40px', padding: '30px', background: '#e8f5e8', borderRadius: '15px', border: '2px solid #52c41a' }}>
            <Title level={3} style={{ color: '#389e0d', marginBottom: '20px' }}>
              ✅ How Lumi Ensures COPPA Compliance
            </Title>
            <Row gutter={[24, 24]}>
              <Col xs={24} md={12}>
                <div style={{ marginBottom: '20px' }}>
                  <Title level={4}>🔒 Data Minimization</Title>
                  <Paragraph style={{ fontSize: '15px' }}>
                    We collect only the minimum data necessary for Lumi to function—no personal identifiers, 
                    location data, or behavioral tracking. Conversations stay on your home network.
                  </Paragraph>
                </div>
                <div style={{ marginBottom: '20px' }}>
                  <Title level={4}>👨‍👩‍👧‍👦 Verifiable Parent Consent</Title>
                  <Paragraph style={{ fontSize: '15px' }}>
                    Before any data collection, parents must provide explicit, verifiable consent through 
                    multiple authentication steps that confirm adult authorization.
                  </Paragraph>
                </div>
              </Col>
              <Col xs={24} md={12}>
                <div style={{ marginBottom: '20px' }}>
                  <Title level={4}>📱 Complete Parent Access</Title>
                  <Paragraph style={{ fontSize: '15px' }}>
                    Parents have 24/7 access to all data through the dashboard, can review any information 
                    collected, and can request immediate deletion at any time.
                  </Paragraph>
                </div>
                <div style={{ marginBottom: '20px' }}>
                  <Title level={4}>🚫 No Third-Party Sharing</Title>
                  <Paragraph style={{ fontSize: '15px' }}>
                    Child data is never shared with advertisers, marketers, or third parties. All processing 
                    happens locally or through COPPA-compliant, encrypted channels only.
                  </Paragraph>
                </div>
              </Col>
            </Row>
          </div>

          {/* Industry Leadership */}
          <div style={{ padding: '30px', background: '#fff', borderRadius: '15px', textAlign: 'center' }}>
            <Title level={3} style={{ color: '#722ed1', marginBottom: '20px' }}>
              🏆 Setting the Standard for Child Privacy Protection
            </Title>
            <Row gutter={[32, 32]} justify="center">
              <Col xs={24} md={8}>
                <div>
                  <div style={{ fontSize: '48px', marginBottom: '15px' }}>🥇</div>
                  <Title level={4}>Privacy by Design</Title>
                  <Text>
                    Built from the ground up with COPPA compliance as a core architectural principle, 
                    not an afterthought.
                  </Text>
                </div>
              </Col>
              <Col xs={24} md={8}>
                <div>
                  <div style={{ fontSize: '48px', marginBottom: '15px' }}>🔍</div>
                  <Title level={4}>Regular Audits</Title>
                  <Text>
                    Independent third-party COPPA compliance audits ensure we exceed requirements 
                    and stay ahead of evolving privacy standards.
                  </Text>
                </div>
              </Col>
              <Col xs={24} md={8}>
                <div>
                  <div style={{ fontSize: '48px', marginBottom: '15px' }}>📚</div>
                  <Title level={4}>Parent Education</Title>
                  <Text>
                    We don't just comply with COPPA—we educate families about digital privacy rights 
                    and empower parents with unprecedented transparency.
                  </Text>
                </div>
              </Col>
            </Row>
            
            <div style={{ marginTop: '30px', padding: '20px', background: '#f6ffed', borderRadius: '10px', border: '1px solid #b7eb8f' }}>
              <Text strong style={{ fontSize: '16px', color: '#389e0d' }}>
                💡 Lumi doesn't just meet COPPA requirements—we exceed them, creating the most transparent, 
                parent-controlled children's technology platform available today.
              </Text>
            </div>
          </div>
        </Card>

        {/* Navigation to other pages */}
        <div style={{ textAlign: 'center', marginBottom: '60px' }}>
          <Title level={3} style={{ marginBottom: '30px' }}>Explore More</Title>
          <Row gutter={[16, 16]} justify="center">
            <Col>
              <Button 
                type="primary" 
                size="large"
                onClick={() => history.push('/')}
                style={{
                  background: '#e74c3c',
                  borderColor: '#e74c3c',
                  height: '50px',
                  fontSize: '16px',
                  padding: '0 30px'
                }}
              >
                Find Your Companion
              </Button>
            </Col>
            <Col>
              <Button 
                size="large"
                onClick={() => history.push('/wellness')}
                style={{
                  height: '50px',
                  fontSize: '16px',
                  padding: '0 30px'
                }}
              >
                How We Help Benefits
              </Button>
            </Col>
          </Row>
        </div>
      </div>

      {/* Mobile Menu Drawer */}
      <Drawer
        title="Menu"
        placement="right"
        onClose={() => setMobileMenuVisible(false)}
        open={mobileMenuVisible}
        width={280}
      >
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <Button
            type="text"
            onClick={() => {
              history.push('/');
              setMobileMenuVisible(false);
            }}
            style={{
              textAlign: 'left',
              fontSize: '16px',
              height: '48px',
              justifyContent: 'flex-start'
            }}
          >
            🧸 Find Your Companion
          </Button>
          <Button
            type="text"
            onClick={() => {
              history.push('/wellness');
              setMobileMenuVisible(false);
            }}
            style={{
              textAlign: 'left',
              fontSize: '16px',
              height: '48px',
              justifyContent: 'flex-start'
            }}
          >
            🌱 How We Help
          </Button>
          <Button
            type="text"
            onClick={() => {
              history.push('/blog');
              setMobileMenuVisible(false);
            }}
            style={{
              textAlign: 'left',
              fontSize: '16px',
              height: '48px',
              justifyContent: 'flex-start'
            }}
          >
            📚 Blog
          </Button>
        </div>
      </Drawer>
    </div>
  );
};

export default CalmiPlatform;